<template>
  <q-chat-message
    class="c-chat-message --user"
    :text="chat.text"
    :stamp="chat.stamp"
    :sent="chat.sent"
  >
    <template #stamp>
      {{ chat.stamp }}
      <button
        v-if="chat.editable"
        type="button"
        class="tw-ml-1 tw-px-1 tw-py-2 tw-underline hover:tw-opacity-70 focus-visible:tw-outline focus-visible:tw-outline-2"
        @click="emit('edit')"
      >
        {{ t("shared.chat.edit") }}
      </button>
    </template>

    <template #avatar>
      <c-avatar
        class="tw-self-end"
        :name="displayName"
        :src="profileImageUrl"
        size="32px"
        font-size="12px"
        :color="chat.sent ? 'blue' : 'gray'"
      >
        <c-tooltip>{{ displayName }}</c-tooltip>
      </c-avatar>
    </template>
  </q-chat-message>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const emit = defineEmits(["edit"]);

const props = defineProps({
  chat: {
    type: Object,
    default: () => ({}),
  },
});

const displayName = computed(
  () => props.chat?.user?.full_name ?? props.chat?.name ?? "",
);

const profileImageUrl = computed(() => {
  const image = props.chat?.user?.profile_image;

  if (!image) {
    return null;
  }

  return `${import.meta.env.VITE_LARAVEL_URL}/${image}`;
});
</script>

<style lang="scss">
.q-message.c-chat-message {
  @apply tw-mb-0;

  &.--user {
    .q-message-text {
      @apply tw-border;

      &.q-message-text--received {
        @apply tw-border-slate-200 tw-bg-slate-50 tw-text-gray-800;
      }

      &.q-message-text--sent {
        @apply tw-border-blue-200 tw-bg-blue-100;
      }
    }
  }

  .q-message-container {
    @apply tw-items-start tw-gap-2;
  }

  .q-message-name {
    @apply tw-mb-1 tw-text-sm;
  }

  .q-message-text {
    @apply tw-rounded-lg tw-p-4;

    &::before {
      @apply tw-hidden;
    }

    &-content {
      @apply tw-text-base;
    }
  }

  .q-message-stamp {
    @apply tw-mt-1 tw-text-left tw-text-xs;
  }
}
</style>
